import Logo from "@/components/tpr/Logo/Logo";
import RandomWallpaper from "@/components/tpr/RandomWallpaper/RandomWallpaper";
import TprIcon from "@/components/tpr/TprIcon/TprIcon";
import { Construction } from "lucide-react";

interface MaintenancePageViewProps {
  message?: string | null;
}

const MaintenancePageView = ({ message }: MaintenancePageViewProps) => {
  return (
    <div className="bg-white dark:bg-gray-900">
      <div className="flex justify-center h-screen">
        <RandomWallpaper />

        <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-3/6">
          <div className="flex-1">
            {/* Logo */}
            <div className="text-center flex flex-col justify-center items-center">
              <div className="mb-4">
                <TprIcon size="large" />
              </div>
              <h2 className="text-4xl font-bold text-center text-gray-700 dark:text-white">
                <Logo color="black" size="large" />
              </h2>
            </div>

            {/* Maintenance Message */}
            <div className="mt-8 text-center">
              <Construction className="size-16 text-amber-500 mx-auto mb-6" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Our booking system is currently unavailable
              </h1>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                {message || "We're currently performing scheduled maintenance. Please check back shortly."}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                We apologise for any inconvenience. If you need urgent assistance, please contact support or your
                practice manager.
              </p>
            </div>

            <span className="text-gray-300 text-xs pt-2 block text-center mt-8">
              {import.meta.env.VITE_COMMIT_HASH || "n/a"} &middot; {import.meta.env.VITE_APP_ENV || "n/a"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePageView;
